export default "__VITE_ASSET__CpDIRurq__"